export class ClientProjectAssignmentDTO {
    id: number;
    clientEmailAddress: string;
    projectId: number;
    active: boolean;
}